
// COURSES UNITS
export const GET_COURSE_UNITS = "/course-units";
export const ADD_NEW_COURSE_UNIT = "/course-units";
export const UPDATE_COURSE_UNIT = "/course-units";
export const DELETE_COURSE_UNIT = "/course-units";


